export default __webpack_public_path__ + "/assets/menneske.b007c335bc402e2a4a170513756d88a0.png";